import { useState, useRef, useEffect } from "react";

export const useSize = () => {
	const refSize = useRef();
	const [size, setSize] = useState();

	useEffect(() => {
		const updateSize = () => {
			const mSize = {
				top: refSize.current.offsetTop,
				left: refSize.current.offsetLeft,
				width: refSize.current.offsetWidth - 1,
				height: refSize.current.offsetHeight - 1,
			};

			setSize(mSize);
		};

		const resizeObserver = new ResizeObserver(() => {
			updateSize();
		});

		if (refSize.current) {
			resizeObserver.observe(refSize.current);
		}

		return () => {
			if (refSize.current) {
				resizeObserver.unobserve(refSize.current);
			}
		};
	}, []);

	return [refSize, size];
};

export default useSize;
